import { render, staticRenderFns } from "./MarginHelpPopup.vue?vue&type=template&id=8e4eb570&scoped=true&"
import script from "./MarginHelpPopup.vue?vue&type=script&lang=js&"
export * from "./MarginHelpPopup.vue?vue&type=script&lang=js&"
import style0 from "./MarginHelpPopup.vue?vue&type=style&index=0&id=8e4eb570&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4eb570",
  null
  
)

export default component.exports